import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '../store';

Vue.use(VueRouter);


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
  },
  {
    path: '/regions',
    name: 'Regions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Regions.vue'),
  },
  {
    path: '/aquaculture',
    name: 'Aquaculture',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Aquaculture.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },
  {
    path: '/aquacultureObject',
    name: 'AquacultureObject',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AquacultureObject.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },
  {
    path: '/business',
    name: 'Business',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Business.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },

  {
    path: '/calculator',
    name: 'Calculator',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Calculator.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },

  {
    path: '/calculator9',
    name: 'Calculator9',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Calculator9.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },

  {
    path: '/calculator12',
    name: 'Calculator12',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Calculator12.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },

  {
    path: '/calculator18',
    name: 'Calculator18',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Calculator18.vue'),
    beforeEnter(to, from, next) {
      const isValidId = store.getters.currentRegion === null
      && store.getters.currentAquaculture === null;
      if (isValidId) {
        next('/regions');
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});


export default router;
